<his-multiselect-plam
	[ddKey]="researchInfrastructureAccessKindDdKey"
	dataSource="researchInfrastructureAccessKindValue"
	[showDropdownIcon] ="false"
	[selectedOptions]="selectedInfrastructureAccesskinds"
	(selectedOptionsChange)="onSelectedInfrastructureAccesskindsChange($event)"
	field="text"
	[editMode]="editMode">
</his-multiselect-plam>
